import { render, staticRenderFns } from "./WarehouseGroceryPlaceholder.vue?vue&type=template&id=5b83070f&scoped=true"
import script from "./WarehouseGroceryPlaceholder.vue?vue&type=script&lang=js"
export * from "./WarehouseGroceryPlaceholder.vue?vue&type=script&lang=js"
import style0 from "./WarehouseGroceryPlaceholder.vue?vue&type=style&index=0&id=5b83070f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b83070f",
  null
  
)

export default component.exports